import React, { Dispatch, useRef, useCallback, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Form } from '@unform/web';
import {
  FiMail,
  FiLock,
  FiUser,
  FiArrowRight,
  FiArrowLeft,
} from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { FaArrowLeft, FaBuilding } from 'react-icons/fa';
import { MdError } from 'react-icons/md';
import { recaptchaKey } from '../../config';
import { Error, LoginContent } from './styles';
import { useAuth } from '../../hooks/Auth';
import Input from '../Input';
import MaskedInput from '../MaskedInput';
import { useToast } from '../../hooks/Toast';

import getValidationErrors from '../../utils/getValidationErrors';
import SelectSimple from '../SelectSimple';

import Button from '../Button';

import api from '../../services/api';
import TextareaInput from '../TextareaInput';
import { ResponseMessage } from '../ResponseMessage';
import Whatsapp from '../WhatsAppCompartilhar';
import Loader from '../Loader';

interface LoginProps {
  [key: string]: string;
}

interface ICode {
  code: string;
}

const LoginContainer: React.FC<ICode> = ({ code }) => {
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);

  const handleNewLogin = async (data: LoginProps) => {
    setLoading(true);

    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Nome obrigatório'),
        email: Yup.string()
          .required('Email obrigatório')
          .email('Preencha um email válido'),

        password: Yup.string().required('Senha obrigatória'),

        country: Yup.string().required('Preencha o campo País'),
        gender: Yup.string().required('Preencha o campo Sexo'),
        extra_4: Yup.string().required('Preencha sua Categoria'),
        state: Yup.string().required('Estado é obrigatório'),
        city: Yup.string().required('Cidade é obrigatório'),
      });

      await schema.validate(data, { abortEarly: false });

      const {
        name,
        email,
        password,

        extra_4,
        gender,
        state,
        city,
      } = data;

      const newUser = await api
        .post('/signup-with-code', {
          name,
          email,
          password,

          extra_4,
          gender,
          state,
          city,
          code,
        })
        .catch(error => {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);

            if (formRef && formRef.current && formRef.current.setErrors) {
              formRef.current.setErrors(errors);
            }
            setLoading(false);

            const errorsString = Object.keys(errors).reduce(
              (prev: Array<string>, key: string): Array<string> => {
                prev = [...prev, errors[key]];
                return prev;
              },
              [],
            );

            setErrorMessage(errorsString);

            return;
          }

          addToast({
            type: 'error',
            title: error.response.data.message,
          });
          setLoading(false);
          return false;
        });

      if (!newUser) {
        setLoading(false);
        return false;
      }

      setSuccess(true);
      setLoading(false);
      return false;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);

        const errorInfo = err.errors.reduce((error, prev) => {
          prev = `${prev}, ${error}`;
          return prev;
        });

        addToast({
          type: 'error',
          title: 'Erro de validação',
          description: errorInfo,
        });
      }
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader message="Carregando" />}
      {success ? (
        <ResponseMessage
          active
          type="success"
          title="Sucesso"
          description={(
            <p>
              Cadastro realizado com sucesso!
              <br />
              <Link to="/login" style={{ margin: '10px auto' }}>
                <Button style={{ width: '100%' }} type="button">
                  Acessar
                </Button>
              </Link>
            </p>
          )}
        />
      ) : (
        <div>
          <LoginContent>
            <div>
              {' '}
              <aside>
                <div>
                  <h2
                    style={{
                      marginBottom: '20px',
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    Nova Inscrição
                  </h2>
                  <Form
                    ref={formRef}
                    onSubmit={handleNewLogin}
                    initialData={{ country: 'Brasil' }}
                  >
                    <div className="formBackground">
                      <Input
                        icon={FiUser}
                        name="name"
                        placeholder="Nome Completo"
                      />

                      <Input icon={FiMail} name="email" placeholder="E-mail" />

                      <SelectSimple
                        options={[
                          { label: 'Masculino', value: 'Masculino' },
                          {
                            label: 'Feminino',
                            value: 'Feminino',
                          },
                          {
                            label: 'Não desejo informar',
                            value: 'Não desejo informar',
                          },
                        ]}
                        name="gender"
                        formRef={formRef}
                        label="Sexo"
                      />

                      <SelectSimple
                        options={[
                          { label: 'Advocacia', value: 'Advocacia' },
                          {
                            label: 'Bacharel em Direito',
                            value: 'Bacharel em Direito',
                          },
                          { label: 'Estudante', value: 'Estudante' },
                          { label: 'Imprensa', value: 'Imprensa' },
                          {
                            label: 'Outros profissionais',
                            value: 'Outros profissionais',
                          },
                        ]}
                        name="extra_4"
                        formRef={formRef}
                        label="Categoria"
                      />

                      <SelectSimple
                        options={[
                          { label: 'Acre (AC)', value: 'AC' },
                          { label: 'Alagoas (AL)', value: 'AL' },
                          { label: 'Amapá (AP)', value: 'AP' },
                          { label: 'Amazonas (AM)', value: 'AM' },
                          { label: 'Bahia (BA)', value: 'BA' },
                          { label: 'Ceará (CE)', value: 'CE' },
                          {
                            label: 'Distrito Federal (DF)',
                            value: 'DF',
                          },
                          {
                            label: 'Espírito Santo (ES)',
                            value: 'ES',
                          },
                          { label: 'Goiás (GO)', value: 'GO' },
                          { label: 'Maranhão (MA)', value: 'MA' },
                          { label: 'Mato Grosso (MT)', value: 'MT' },
                          {
                            label: 'Mato Grosso do Sul (MS)',
                            value: 'MS',
                          },
                          { label: 'Minas Gerais (MG)', value: 'MG' },
                          { label: 'Pará (PA)', value: 'PA' },
                          { label: 'Paraíba (PB)', value: 'PB' },
                          { label: 'Paraná (PR)', value: 'PR' },
                          { label: 'Pernambuco (PE)', value: 'PE' },
                          { label: 'Piauí (PI)', value: 'PI' },
                          {
                            label: 'Rio de Janeiro (RJ)',
                            value: 'RJ',
                          },
                          {
                            label: 'Rio Grande do Norte (RN)',
                            value: 'RN',
                          },
                          {
                            label: 'Rio Grande do Sul (RS)',
                            value: 'RS',
                          },
                          { label: 'Rondônia (RO)', value: 'RO' },
                          { label: 'Roraima (RR)', value: 'RR' },
                          {
                            label: 'Santa Catarina (SC)',
                            value: 'SC',
                          },
                          { label: 'São Paulo (SP)', value: 'SP' },
                          { label: 'Sergipe (SE)', value: 'SE' },
                          { label: 'Tocantins (TO)', value: 'TO' },
                          {
                            label: 'Não sou Brasileiro',
                            value: 'Não sou Brasileiro',
                          },
                        ]}
                        name="state"
                        formRef={formRef}
                        label="Estado"
                      />
                      <Input
                        icon={FaBuilding}
                        name="city"
                        placeholder="Cidade"
                      />
                      <Input
                        icon={FaBuilding}
                        name="country"
                        placeholder="País"
                      />
                      <Input
                        icon={FiLock}
                        name="password"
                        type="password"
                        placeholder="senha"
                      />
                      <p
                        style={{
                          padding: '10px',
                          background: 'none',
                          margin: '5px auto',
                          color: '#fff',
                          fontSize: '12px',
                          textAlign: 'left',
                        }}
                      >
                        Ao me cadastrar, afirmo que li e aceito os
{' '}
                        <strong>
                          <Link
                            style={{ display: 'inline', color: '#fff' }}
                            to="/termos"
                            target="_BLANK"
                          >
                            termos
{' '}
                          </Link>
{' '}
                        </strong>
                        para inscrição.
                      </p>
                      <div
                        style={{
                          width: '100%',
                          justifyContent: 'center',
                          display: 'flex',
                        }}
                      >
                        <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />
                      </div>
                    </div>
                    {errorMessage && (
                      <Error>
                        {errorMessage.map((item, index) => (
                          <div key={`error${index}`}>
                            <MdError />
                            {item}
                          </div>
                        ))}
                      </Error>
                    )}

                    <Button style={{ margin: '10px auto' }} type="submit">
                      CADASTRAR
                    </Button>
                  </Form>
                </div>
              </aside>
            </div>
          </LoginContent>
        </div>
      )}
    </>
  );
};

export default LoginContainer;
